class RPRotator extends HTMLElement {
  connectedCallback() {
    this.slides = [...this.querySelectorAll('[data-slide]')];
    this.index = 0;
    this.paused = matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.abort = new AbortController();
    const options = {signal:this.abort.signal};
    this.addEventListener('click', event => {
      const button = event.target.closest('button');
      if (!button) return;
      if (button.hasAttribute('data-next')) this.show(this.index + 1);
      if (button.hasAttribute('data-previous')) this.show(this.index - 1);
      if (button.hasAttribute('data-slide-to')) this.show(Number(button.dataset.slideTo));
      if (button.hasAttribute('data-pause')) {
        this.paused = !this.paused;
        button.setAttribute('aria-pressed', String(this.paused));
        button.setAttribute('aria-label', this.paused ? button.dataset.playLabel : button.dataset.pauseLabel);
      }
    }, options);
    if (this.dataset.autoplay === 'true' && this.slides.length > 1) {
      this.timer = setInterval(() => {
        if (!this.paused && !this.matches(':hover') && !this.contains(document.activeElement) && !document.hidden) this.show(this.index + 1);
      }, Number(this.dataset.delay) || 5000);
    }
  }
  show(index) {
    if (!this.slides.length) return;
    this.index = (index + this.slides.length) % this.slides.length;
    this.slides.forEach((slide, i) => { slide.hidden = i !== this.index; });
    this.querySelectorAll('[data-slide-to]').forEach((button, i) => button.setAttribute('aria-current', String(i === this.index)));
  }
  disconnectedCallback() { clearInterval(this.timer); this.abort?.abort(); }
}
if (!customElements.get('rp-rotator')) customElements.define('rp-rotator', RPRotator);

(() => {
  const closeMenu = (restoreFocus = false) => {
    const opener = document.querySelector('[data-menu-toggle][aria-expanded=true]');
    document.querySelectorAll('.rp-mobile-menu').forEach(menu => { menu.hidden = true; });
    document.querySelectorAll('[data-menu-toggle]').forEach(button => button.setAttribute('aria-expanded','false'));
    document.body.classList.remove('rp-menu-open');
    if(restoreFocus) opener?.focus();
  };
  const initCarousels = (scope = document) => scope.querySelectorAll('[data-carousel]').forEach(carousel => {
    if (carousel.dataset.initialized) return;
    carousel.dataset.initialized = 'true';
    const track = carousel.querySelector('[data-carousel-track]');
    const prev = carousel.querySelector('[data-carousel-prev]');
    const next = carousel.querySelector('[data-carousel-next]');
    const update = () => {
      if(prev) prev.disabled = track.scrollLeft < 2;
      if(next) next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
      const progress = carousel.querySelector('[data-carousel-progress]');
      if(progress && track.scrollWidth) {
        progress.style.setProperty('--rp-progress-width',`${track.clientWidth / track.scrollWidth * 100}%`);
        progress.style.setProperty('--rp-progress-left',`${track.scrollLeft / track.clientWidth * 100}%`);
      }
    };
    track.addEventListener('scroll',update,{passive:true});
    new ResizeObserver(update).observe(track);
    update();
  });
  document.addEventListener('click', event => {
    const toggle = event.target.closest('[data-menu-toggle]');
    if (toggle) {
      const menu = document.getElementById(toggle.getAttribute('aria-controls'));
      const open = menu.hidden;
      closeMenu();
      if(open) {
        menu.style.setProperty('--rp-menu-top',`${toggle.closest('header').getBoundingClientRect().bottom}px`);
        menu.hidden = false;
        toggle.setAttribute('aria-expanded','true');
        document.body.classList.add('rp-menu-open');
        menu.querySelector('a,summary')?.focus();
      }
    }
    const opener = event.target.closest('[data-dialog-open]');
    if (opener) {
      closeMenu();
      const dialog = document.getElementById(opener.dataset.dialogOpen);
      if(dialog) { dialog.rpOpener = opener; dialog.showModal(); }
    }
    const queryButton = event.target.closest('[data-search-term]');
    if(queryButton) {
      const input = queryButton.closest('dialog').querySelector('[name=q]');
      input.value = queryButton.dataset.searchTerm;
      input.dispatchEvent(new Event('input',{bubbles:true}));
      input.focus();
    }
    if(event.target.closest('[data-rp-cart-close]')) document.querySelector('cart-drawer')?.close();
    const closer = event.target.closest('[data-dialog-close]');
    if(closer) closer.closest('dialog').close();
    if(event.target.matches('dialog')) {
      const rect = event.target.getBoundingClientRect();
      if(event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) event.target.close();
    }
    const tab = event.target.closest('.rp-tabs [role=tab]');
    if(tab) {
      const section = tab.closest('.rp-featured-tabs');
      section.querySelectorAll('[role=tab]').forEach(button => {const active = button === tab;button.setAttribute('aria-selected',String(active));button.tabIndex = active ? 0 : -1;});
      section.querySelectorAll('[role=tabpanel]').forEach(panel => {panel.hidden = panel.id !== tab.getAttribute('aria-controls');});
    }
    const arrow = event.target.closest('[data-carousel-prev],[data-carousel-next]');
    if(arrow) {
      const track = arrow.closest('[data-carousel]').querySelector('[data-carousel-track]');
      const card = track.firstElementChild;
      const distance = card.getBoundingClientRect().width + parseFloat(getComputedStyle(track).gap);
      track.scrollBy({left:arrow.hasAttribute('data-carousel-prev') ? -distance : distance,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
    }
    if(event.target.closest('[data-back-to-top]')) window.scrollTo({top:0,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
  });
  document.addEventListener('close',event => { if(event.target.matches('dialog')) event.target.rpOpener?.focus(); },true);
  document.addEventListener('keydown',event => {
    if(event.key === 'Escape') closeMenu(true);
    const tab = event.target.closest('.rp-tabs [role=tab]');
    if(tab && ['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) {
      event.preventDefault();
      const tabs = [...tab.parentElement.querySelectorAll('[role=tab]')];
      const index = tabs.indexOf(tab);
      const target = event.key === 'Home' ? tabs[0] : event.key === 'End' ? tabs.at(-1) : tabs[(index + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length];
      target.click();target.focus();
    }
    const menu = document.querySelector('.rp-mobile-menu:not([hidden])');
    if(menu && event.key === 'Tab') {
      const header = menu.closest('header');
      const focusables = [...header.querySelectorAll('a,button,summary')].filter(el=>el.getClientRects().length);
      const first = focusables[0], last = focusables.at(-1);
      if(event.shiftKey && document.activeElement === first) {event.preventDefault();last.focus();}
      else if(!event.shiftKey && document.activeElement === last) {event.preventDefault();first.focus();}
    }
  });
  const searches = new WeakMap();
  document.addEventListener('input',event=>{
    const input = event.target.closest('[data-rp-search]');
    if(!input) return;
    const previous = searches.get(input);
    clearTimeout(previous?.timer);previous?.controller.abort();
    const results = document.getElementById(input.getAttribute('aria-controls'));
    const query = input.value.trim();
    const suggestions = input.closest('dialog').querySelector('.rp-search-terms');
    if(suggestions) suggestions.hidden = Boolean(query);
    if(!query) {results.replaceChildren();input.setAttribute('aria-expanded','false');return;}
    const controller = new AbortController();
    const timer = setTimeout(async()=>{
      try {
        const params = new URLSearchParams({q:query,'resources[type]':'product','resources[limit]':'5',section_id:'rp-predictive-search'});
        const response = await fetch(`${input.dataset.rpSearch}?${params}`,{signal:controller.signal});
        if(!response.ok) return;
        const html = new DOMParser().parseFromString(await response.text(),'text/html');
        const suggestions = html.querySelector('.rp-suggestions');
        results.replaceChildren();
        if(suggestions) {results.append(suggestions);input.setAttribute('aria-expanded','true');}
      } catch(reason) { if(reason.name !== 'AbortError') input.setAttribute('aria-expanded','false'); }
    },250);
    searches.set(input,{timer,controller});
  });
  document.addEventListener('change',event => {
    if(event.target.matches('.rp-product-form select')) {
      const dialog = event.target.closest('dialog');
      if(dialog) dialog.querySelector('[data-variant-price]').textContent = event.target.selectedOptions[0].dataset.price;
    }
    if(event.target.matches('.rp-footer__localization select')) event.target.form.requestSubmit();
  });
  document.addEventListener('submit',async event => {
    if(!event.target.matches('.rp-product-form')) return;
    const drawer = document.querySelector('cart-drawer');
    if(!drawer) return;
    event.preventDefault();
    const form = event.target;
    const button = form.querySelector('[type=submit]');
    const error = form.querySelector('[data-form-error]');
    if(!button || !error) {form.submit();return;}
    const purchaseButtons = [button,...document.querySelectorAll(`[data-sticky-add][form="${form.id}"]`)];
    purchaseButtons.forEach(control=>control.disabled=true);error.hidden = true;
    try {
      const data = new FormData(form);
      data.append('sections', drawer.getSectionsToRender().map(section=>section.id).join(','));
      data.append('sections_url',location.pathname);
      const response = await fetch(`${form.action}.js`,{method:'POST',body:data,headers:{Accept:'application/json','X-Requested-With':'XMLHttpRequest'}});
      const result = await response.json();
      if(!response.ok || result.status) throw new Error(result.description || result.message);
      form.closest('dialog')?.close();
      drawer.classList.remove('is-empty');
      drawer.renderContents(result);
    } catch(reason) { error.textContent = reason.message;error.hidden = false; }
    finally { const variant = form.querySelector('[data-pdp-variant]'); const page = form.closest('rp-product'); const unavailable = Boolean(page && page.variants.find(item=>String(item.id)===String(variant?.value || form.querySelector('[name=id]').value))?.available === false); purchaseButtons.forEach(control=>control.disabled=unavailable); }
  });
  document.addEventListener('shopify:section:load',event=>initCarousels(event.target));
  document.addEventListener('shopify:block:select',event=>{
    const rotator = event.target.closest('rp-rotator');
    if(rotator) {rotator.paused=true;rotator.show(rotator.slides.indexOf(event.target.closest('[data-slide]')));}
    const tab = event.target.closest('[role=tab]');if(tab) tab.click();
  });
  window.addEventListener('resize',()=>closeMenu());
  initCarousels();
})();
